/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/customer/service.proto" (package "rd.api.customer", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CustomerService } from "./service_pb";
import type { DetachCustomerTagRes } from "./service_pb";
import type { DetachCustomerTagReq } from "./service_pb";
import type { AttachCustomerTagRes } from "./service_pb";
import type { AttachCustomerTagReq } from "./service_pb";
import type { AttachNewCustomerTagRes } from "./service_pb";
import type { AttachNewCustomerTagReq } from "./service_pb";
import type { ListCustomerTagsRes } from "./service_pb";
import type { ListCustomerTagsReq } from "./service_pb";
import type { ConvertToJobRes } from "./service_pb";
import type { ConvertToJobReq } from "./service_pb";
import type { UpdateCustomerShouldReceiveJobStatementsRes } from "./service_pb";
import type { UpdateCustomerShouldReceiveJobStatementsReq } from "./service_pb";
import type { CreateJobRes } from "./service_pb";
import type { CreateJobReq } from "./service_pb";
import type { GenerateNextJobIdentifierRes } from "./service_pb";
import type { GenerateNextJobIdentifierReq } from "./service_pb";
import type { BulkUpsertJobsRes } from "./service_pb";
import type { BulkUpsertJobsReq } from "./service_pb";
import type { BulkUpsertCustomerContactsRes } from "./service_pb";
import type { BulkUpsertCustomerContactsReq } from "./service_pb";
import type { BulkUpsertCustomersRes } from "./service_pb";
import type { BulkUpsertCustomersReq } from "./service_pb";
import type { EmailContractorRewardsInvitationRes } from "./service_pb";
import type { EmailContractorRewardsInvitationReq } from "./service_pb";
import type { EmailCustomerSaleHistoryPDFRes } from "./service_pb";
import type { EmailCustomerSaleHistoryPDFReq } from "./service_pb";
import type { GetCustomerSaleHistoryPDFRes } from "./service_pb";
import type { GetCustomerSaleHistoryPDFReq } from "./service_pb";
import type { DeactivateCustomerContactRes } from "./service_pb";
import type { DeactivateCustomerContactReq } from "./service_pb";
import type { UpdateCustomerContactRes } from "./service_pb";
import type { UpdateCustomerContactReq } from "./service_pb";
import type { CreateCustomerContactRes } from "./service_pb";
import type { CreateCustomerContactReq } from "./service_pb";
import type { GetCustomerSavedBankAccountsRes } from "./service_pb";
import type { GetCustomerSavedBankAccountsReq } from "./service_pb";
import type { SendACHPaymentEmailAndSmsRes } from "./service_pb";
import type { SendACHPaymentEmailAndSmsReq } from "./service_pb";
import type { UpdateCustomerCardRes } from "./service_pb";
import type { UpdateCustomerCardReq } from "./service_pb";
import type { AddCustomerCardRes } from "./service_pb";
import type { AddCustomerCardReq } from "./service_pb";
import type { DeleteCustomerCardRes } from "./service_pb";
import type { DeleteCustomerCardReq } from "./service_pb";
import type { UpdateCustomerPrimaryCardRes } from "./service_pb";
import type { UpdateCustomerPrimaryCardReq } from "./service_pb";
import type { GetCustomerSavedCardsRes } from "./service_pb";
import type { GetCustomerSavedCardsReq } from "./service_pb";
import type { GenerateAndSendIndividualCustomerStatementRes } from "./service_pb";
import type { GenerateAndSendIndividualCustomerStatementReq } from "./service_pb";
import type { GetLastStatementRunSendStatsRes } from "./service_pb";
import type { GetLastStatementRunSendStatsReq } from "./service_pb";
import type { GetLastStatementRunIdRes } from "./service_pb";
import type { GetLastStatementRunIdReq } from "./service_pb";
import type { GenerateStatementRunPdfsRes } from "./service_pb";
import type { GenerateStatementRunPdfsReq } from "./service_pb";
import type { UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes } from "./service_pb";
import type { UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq } from "./service_pb";
import type { CountCustomersForBulkStatementRes } from "./service_pb";
import type { CountCustomersForBulkStatementReq } from "./service_pb";
import type { EmailAllInStatementRunRes } from "./service_pb";
import type { EmailAllInStatementRunReq } from "./service_pb";
import type { GetStatementRunStatsRes } from "./service_pb";
import type { GetStatementRunStatsReq } from "./service_pb";
import type { GetStatementRunRes } from "./service_pb";
import type { GetStatementRunReq } from "./service_pb";
import type { EmailStatementRunRes } from "./service_pb";
import type { EmailStatementRunReq } from "./service_pb";
import type { BulkGenerateStatementsForCustomersRes } from "./service_pb";
import type { BulkGenerateStatementsForCustomersReq } from "./service_pb";
import type { GenerateStatementsForCustomersRes } from "./service_pb";
import type { GenerateStatementsForCustomersReq } from "./service_pb";
import type { EmailCustomerStatementPDFRes } from "./service_pb";
import type { EmailCustomerStatementPDFReq } from "./service_pb";
import type { ListStatementsForCustomerRes } from "./service_pb";
import type { ListStatementsForCustomerReq } from "./service_pb";
import type { MailBulkStatementRunRes } from "./service_pb";
import type { MailBulkStatementRunReq } from "./service_pb";
import type { GetLastStatementRunRes } from "./service_pb";
import type { GetLastStatementRunReq } from "./service_pb";
import type { MergeCustomersRes } from "./service_pb";
import type { MergeCustomersReq } from "./service_pb";
import type { UpdateCustomerIsCardSurchargeExemptRes } from "./service_pb";
import type { UpdateCustomerIsCardSurchargeExemptReq } from "./service_pb";
import type { UpdateCustomerTypeRes } from "./service_pb";
import type { UpdateCustomerTypeReq } from "./service_pb";
import type { UpdateCustomerStatementTypeRes } from "./service_pb";
import type { UpdateCustomerStatementTypeReq } from "./service_pb";
import type { UpdateCustomerShouldHidePricesOnInvoicesRes } from "./service_pb";
import type { UpdateCustomerShouldHidePricesOnInvoicesReq } from "./service_pb";
import type { UpdateCustomerStatementInvoicesFormatRes } from "./service_pb";
import type { UpdateCustomerStatementInvoicesFormatReq } from "./service_pb";
import type { UpdateCustomerShouldRequireJobRes } from "./service_pb";
import type { UpdateCustomerShouldRequireJobReq } from "./service_pb";
import type { ValidateFanBuilderLoyaltyCouponRes } from "./service_pb";
import type { ValidateFanBuilderLoyaltyCouponReq } from "./service_pb";
import type { UnenrollCustomerFromFanBuilderLoyaltyRes } from "./service_pb";
import type { UnenrollCustomerFromFanBuilderLoyaltyReq } from "./service_pb";
import type { GetCustomerFanBuilderLoyaltyRes } from "./service_pb";
import type { GetCustomerFanBuilderLoyaltyReq } from "./service_pb";
import type { EnrollCustomerInFanBuilderLoyaltyRes } from "./service_pb";
import type { EnrollCustomerInFanBuilderLoyaltyReq } from "./service_pb";
import type { GetActiveCustomerCountRes } from "./service_pb";
import type { GetActiveCustomerCountReq } from "./service_pb";
import type { GetJobCountForCustomerRes } from "./service_pb";
import type { GetJobCountForCustomerReq } from "./service_pb";
import type { GetCustomerCountForTierRes } from "./service_pb";
import type { GetCustomerCountForTierReq } from "./service_pb";
import type { ListCustomersForRepRes } from "./service_pb";
import type { ListCustomersForRepReq } from "./service_pb";
import type { UpdateCustomerSalesReminderRes } from "./service_pb";
import type { UpdateCustomerSalesReminderReq } from "./service_pb";
import type { UpdateCustomerGeneralInfoMobileRes } from "./service_pb";
import type { UpdateCustomerGeneralInfoMobileReq } from "./service_pb";
import type { UpdateCustomerPricingTierRes } from "./service_pb";
import type { UpdateCustomerPricingTierReq } from "./service_pb";
import type { UpdateCustomerShouldRequireReceiptSignatureRes } from "./service_pb";
import type { UpdateCustomerShouldRequireReceiptSignatureReq } from "./service_pb";
import type { UpdateCustomerContractorRewardsRes } from "./service_pb";
import type { UpdateCustomerContractorRewardsReq } from "./service_pb";
import type { ListInteractionsForCustomerRes } from "./service_pb";
import type { ListInteractionsForCustomerReq } from "./service_pb";
import type { ListPurchaseOrdersForCustomerRes } from "./service_pb";
import type { ListPurchaseOrdersForCustomerReq } from "./service_pb";
import type { UpdateCustomerRepRes } from "./service_pb";
import type { UpdateCustomerRepReq } from "./service_pb";
import type { UpdateCustomerFinanceChargeSettingRes } from "./service_pb";
import type { UpdateCustomerFinanceChargeSettingReq } from "./service_pb";
import type { UpdateCustomerFinancingTermRes } from "./service_pb";
import type { UpdateCustomerFinancingTermReq } from "./service_pb";
import type { UpdateCustomerShouldRequireInternalSaleNotesRes } from "./service_pb";
import type { UpdateCustomerShouldRequireInternalSaleNotesReq } from "./service_pb";
import type { UpdateCustomerShouldRequireSaleNotesRes } from "./service_pb";
import type { UpdateCustomerShouldRequireSaleNotesReq } from "./service_pb";
import type { UpdateCustomerShouldRequireCustomerContactRes } from "./service_pb";
import type { UpdateCustomerShouldRequireCustomerContactReq } from "./service_pb";
import type { UpdateCustomerShouldMailStatementsRes } from "./service_pb";
import type { UpdateCustomerShouldMailStatementsReq } from "./service_pb";
import type { UpdateCustomerShouldAutopayStatementBalancesRes } from "./service_pb";
import type { UpdateCustomerShouldAutopayStatementBalancesReq } from "./service_pb";
import type { UpdateCustomerShouldPrintInvoicesAndReceiptsRes } from "./service_pb";
import type { UpdateCustomerShouldPrintInvoicesAndReceiptsReq } from "./service_pb";
import type { UpdateCustomerShouldRequirePORes } from "./service_pb";
import type { UpdateCustomerShouldRequirePOReq } from "./service_pb";
import type { UpdateCustomerIsActiveRes } from "./service_pb";
import type { UpdateCustomerIsActiveReq } from "./service_pb";
import type { UpdateCustomerIsOnCreditHoldRes } from "./service_pb";
import type { UpdateCustomerIsOnCreditHoldReq } from "./service_pb";
import type { UpdateCustomerCreditLimitRes } from "./service_pb";
import type { UpdateCustomerCreditLimitReq } from "./service_pb";
import type { UpdateCustomerNotesRes } from "./service_pb";
import type { UpdateCustomerNotesReq } from "./service_pb";
import type { UpdateCustomerExemptionsRes } from "./service_pb";
import type { UpdateCustomerExemptionsReq } from "./service_pb";
import type { UpdateCustomerGeneralInformationRes } from "./service_pb";
import type { UpdateCustomerGeneralInformationReq } from "./service_pb";
import type { CreateCustomerInteractionRes } from "./service_pb";
import type { CreateCustomerInteractionReq } from "./service_pb";
import type { DuplicateCustomerRes } from "./service_pb";
import type { DuplicateCustomerReq } from "./service_pb";
import type { CreateCustomerRes } from "./service_pb";
import type { CreateCustomerReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetCustomerRes } from "./service_pb";
import type { GetCustomerReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.customer.CustomerService
 */
export interface ICustomerServiceClient {
    /**
     * Customer
     *
     * @generated from protobuf rpc: GetCustomer
     */
    getCustomer(input: GetCustomerReq, options?: RpcOptions): UnaryCall<GetCustomerReq, GetCustomerRes>;
    /**
     * @generated from protobuf rpc: CreateCustomer
     */
    createCustomer(input: CreateCustomerReq, options?: RpcOptions): UnaryCall<CreateCustomerReq, CreateCustomerRes>;
    /**
     * @generated from protobuf rpc: DuplicateCustomer
     */
    duplicateCustomer(input: DuplicateCustomerReq, options?: RpcOptions): UnaryCall<DuplicateCustomerReq, DuplicateCustomerRes>;
    /**
     * @generated from protobuf rpc: CreateCustomerInteraction
     */
    createCustomerInteraction(input: CreateCustomerInteractionReq, options?: RpcOptions): UnaryCall<CreateCustomerInteractionReq, CreateCustomerInteractionRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerGeneralInformation
     */
    updateCustomerGeneralInformation(input: UpdateCustomerGeneralInformationReq, options?: RpcOptions): UnaryCall<UpdateCustomerGeneralInformationReq, UpdateCustomerGeneralInformationRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerExemptions
     */
    updateCustomerExemptions(input: UpdateCustomerExemptionsReq, options?: RpcOptions): UnaryCall<UpdateCustomerExemptionsReq, UpdateCustomerExemptionsRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerNotes
     */
    updateCustomerNotes(input: UpdateCustomerNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerNotesReq, UpdateCustomerNotesRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerCreditLimit
     */
    updateCustomerCreditLimit(input: UpdateCustomerCreditLimitReq, options?: RpcOptions): UnaryCall<UpdateCustomerCreditLimitReq, UpdateCustomerCreditLimitRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerIsOnCreditHold
     */
    updateCustomerIsOnCreditHold(input: UpdateCustomerIsOnCreditHoldReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsOnCreditHoldReq, UpdateCustomerIsOnCreditHoldRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerIsActive
     */
    updateCustomerIsActive(input: UpdateCustomerIsActiveReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsActiveReq, UpdateCustomerIsActiveRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequirePO
     */
    updateCustomerShouldRequirePO(input: UpdateCustomerShouldRequirePOReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequirePOReq, UpdateCustomerShouldRequirePORes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldPrintInvoicesAndReceipts
     */
    updateCustomerShouldPrintInvoicesAndReceipts(input: UpdateCustomerShouldPrintInvoicesAndReceiptsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldPrintInvoicesAndReceiptsReq, UpdateCustomerShouldPrintInvoicesAndReceiptsRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldAutopayStatementBalances
     */
    updateCustomerShouldAutopayStatementBalances(input: UpdateCustomerShouldAutopayStatementBalancesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldAutopayStatementBalancesReq, UpdateCustomerShouldAutopayStatementBalancesRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldMailStatements
     */
    updateCustomerShouldMailStatements(input: UpdateCustomerShouldMailStatementsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldMailStatementsReq, UpdateCustomerShouldMailStatementsRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireCustomerContact
     */
    updateCustomerShouldRequireCustomerContact(input: UpdateCustomerShouldRequireCustomerContactReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireCustomerContactReq, UpdateCustomerShouldRequireCustomerContactRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireSaleNotes
     */
    updateCustomerShouldRequireSaleNotes(input: UpdateCustomerShouldRequireSaleNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireSaleNotesReq, UpdateCustomerShouldRequireSaleNotesRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireInternalSaleNotes
     */
    updateCustomerShouldRequireInternalSaleNotes(input: UpdateCustomerShouldRequireInternalSaleNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireInternalSaleNotesReq, UpdateCustomerShouldRequireInternalSaleNotesRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerFinancingTerm
     */
    updateCustomerFinancingTerm(input: UpdateCustomerFinancingTermReq, options?: RpcOptions): UnaryCall<UpdateCustomerFinancingTermReq, UpdateCustomerFinancingTermRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerFinanceChargeSetting
     */
    updateCustomerFinanceChargeSetting(input: UpdateCustomerFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<UpdateCustomerFinanceChargeSettingReq, UpdateCustomerFinanceChargeSettingRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerRep
     */
    updateCustomerRep(input: UpdateCustomerRepReq, options?: RpcOptions): UnaryCall<UpdateCustomerRepReq, UpdateCustomerRepRes>;
    /**
     * @generated from protobuf rpc: ListPurchaseOrdersForCustomer
     */
    listPurchaseOrdersForCustomer(input: ListPurchaseOrdersForCustomerReq, options?: RpcOptions): UnaryCall<ListPurchaseOrdersForCustomerReq, ListPurchaseOrdersForCustomerRes>;
    /**
     * @generated from protobuf rpc: ListInteractionsForCustomer
     */
    listInteractionsForCustomer(input: ListInteractionsForCustomerReq, options?: RpcOptions): UnaryCall<ListInteractionsForCustomerReq, ListInteractionsForCustomerRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerContractorRewards
     */
    updateCustomerContractorRewards(input: UpdateCustomerContractorRewardsReq, options?: RpcOptions): UnaryCall<UpdateCustomerContractorRewardsReq, UpdateCustomerContractorRewardsRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireReceiptSignature
     */
    updateCustomerShouldRequireReceiptSignature(input: UpdateCustomerShouldRequireReceiptSignatureReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireReceiptSignatureReq, UpdateCustomerShouldRequireReceiptSignatureRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerPricingTier
     */
    updateCustomerPricingTier(input: UpdateCustomerPricingTierReq, options?: RpcOptions): UnaryCall<UpdateCustomerPricingTierReq, UpdateCustomerPricingTierRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerGeneralInfoMobile
     */
    updateCustomerGeneralInfoMobile(input: UpdateCustomerGeneralInfoMobileReq, options?: RpcOptions): UnaryCall<UpdateCustomerGeneralInfoMobileReq, UpdateCustomerGeneralInfoMobileRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerSalesReminder
     */
    updateCustomerSalesReminder(input: UpdateCustomerSalesReminderReq, options?: RpcOptions): UnaryCall<UpdateCustomerSalesReminderReq, UpdateCustomerSalesReminderRes>;
    /**
     * @generated from protobuf rpc: ListCustomersForRep
     */
    listCustomersForRep(input: ListCustomersForRepReq, options?: RpcOptions): UnaryCall<ListCustomersForRepReq, ListCustomersForRepRes>;
    /**
     * @generated from protobuf rpc: GetCustomerCountForTier
     */
    getCustomerCountForTier(input: GetCustomerCountForTierReq, options?: RpcOptions): UnaryCall<GetCustomerCountForTierReq, GetCustomerCountForTierRes>;
    /**
     * @generated from protobuf rpc: GetJobCountForCustomer
     */
    getJobCountForCustomer(input: GetJobCountForCustomerReq, options?: RpcOptions): UnaryCall<GetJobCountForCustomerReq, GetJobCountForCustomerRes>;
    /**
     * @generated from protobuf rpc: GetActiveCustomerCount
     */
    getActiveCustomerCount(input: GetActiveCustomerCountReq, options?: RpcOptions): UnaryCall<GetActiveCustomerCountReq, GetActiveCustomerCountRes>;
    /**
     * Fan Builder loyalty (FLAG_REWARD_PROGRAM_FAN_BUILDER). Human (non-job) customers only.
     *
     * @generated from protobuf rpc: EnrollCustomerInFanBuilderLoyalty
     */
    enrollCustomerInFanBuilderLoyalty(input: EnrollCustomerInFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<EnrollCustomerInFanBuilderLoyaltyReq, EnrollCustomerInFanBuilderLoyaltyRes>;
    /**
     * @generated from protobuf rpc: GetCustomerFanBuilderLoyalty
     */
    getCustomerFanBuilderLoyalty(input: GetCustomerFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<GetCustomerFanBuilderLoyaltyReq, GetCustomerFanBuilderLoyaltyRes>;
    /**
     * Removes the customer from Fan Builder (CES Customer/Delete) and clears the stored
     * enrollment (FLAG_REWARD_PROGRAM_FAN_BUILDER).
     *
     * @generated from protobuf rpc: UnenrollCustomerFromFanBuilderLoyalty
     */
    unenrollCustomerFromFanBuilderLoyalty(input: UnenrollCustomerFromFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<UnenrollCustomerFromFanBuilderLoyaltyReq, UnenrollCustomerFromFanBuilderLoyaltyRes>;
    /**
     * POS scanned barcode: Coupon/ValidateCoupon (FLAG_REWARD_PROGRAM_FAN_BUILDER).
     *
     * @generated from protobuf rpc: ValidateFanBuilderLoyaltyCoupon
     */
    validateFanBuilderLoyaltyCoupon(input: ValidateFanBuilderLoyaltyCouponReq, options?: RpcOptions): UnaryCall<ValidateFanBuilderLoyaltyCouponReq, ValidateFanBuilderLoyaltyCouponRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireJob
     */
    updateCustomerShouldRequireJob(input: UpdateCustomerShouldRequireJobReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireJobReq, UpdateCustomerShouldRequireJobRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerStatementInvoicesFormat
     */
    updateCustomerStatementInvoicesFormat(input: UpdateCustomerStatementInvoicesFormatReq, options?: RpcOptions): UnaryCall<UpdateCustomerStatementInvoicesFormatReq, UpdateCustomerStatementInvoicesFormatRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldHidePricesOnInvoices
     */
    updateCustomerShouldHidePricesOnInvoices(input: UpdateCustomerShouldHidePricesOnInvoicesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldHidePricesOnInvoicesReq, UpdateCustomerShouldHidePricesOnInvoicesRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerStatementType
     */
    updateCustomerStatementType(input: UpdateCustomerStatementTypeReq, options?: RpcOptions): UnaryCall<UpdateCustomerStatementTypeReq, UpdateCustomerStatementTypeRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerType
     */
    updateCustomerType(input: UpdateCustomerTypeReq, options?: RpcOptions): UnaryCall<UpdateCustomerTypeReq, UpdateCustomerTypeRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerIsCardSurchargeExempt
     */
    updateCustomerIsCardSurchargeExempt(input: UpdateCustomerIsCardSurchargeExemptReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsCardSurchargeExemptReq, UpdateCustomerIsCardSurchargeExemptRes>;
    /**
     * @generated from protobuf rpc: MergeCustomers
     */
    mergeCustomers(input: MergeCustomersReq, options?: RpcOptions): UnaryCall<MergeCustomersReq, MergeCustomersRes>;
    /**
     * Statement
     *
     * @generated from protobuf rpc: GetLastStatementRun
     */
    getLastStatementRun(input: GetLastStatementRunReq, options?: RpcOptions): UnaryCall<GetLastStatementRunReq, GetLastStatementRunRes>;
    /**
     * @generated from protobuf rpc: MailBulkStatementRun
     */
    mailBulkStatementRun(input: MailBulkStatementRunReq, options?: RpcOptions): UnaryCall<MailBulkStatementRunReq, MailBulkStatementRunRes>;
    /**
     * @generated from protobuf rpc: ListStatementsForCustomer
     */
    listStatementsForCustomer(input: ListStatementsForCustomerReq, options?: RpcOptions): UnaryCall<ListStatementsForCustomerReq, ListStatementsForCustomerRes>;
    /**
     * @generated from protobuf rpc: EmailCustomerStatementPDF
     */
    emailCustomerStatementPDF(input: EmailCustomerStatementPDFReq, options?: RpcOptions): UnaryCall<EmailCustomerStatementPDFReq, EmailCustomerStatementPDFRes>;
    /**
     * @generated from protobuf rpc: GenerateStatementsForCustomers
     */
    generateStatementsForCustomers(input: GenerateStatementsForCustomersReq, options?: RpcOptions): UnaryCall<GenerateStatementsForCustomersReq, GenerateStatementsForCustomersRes>;
    /**
     * @generated from protobuf rpc: BulkGenerateStatementsForCustomers
     */
    bulkGenerateStatementsForCustomers(input: BulkGenerateStatementsForCustomersReq, options?: RpcOptions): UnaryCall<BulkGenerateStatementsForCustomersReq, BulkGenerateStatementsForCustomersRes>;
    /**
     * @generated from protobuf rpc: EmailStatementRun
     */
    emailStatementRun(input: EmailStatementRunReq, options?: RpcOptions): UnaryCall<EmailStatementRunReq, EmailStatementRunRes>;
    /**
     * @generated from protobuf rpc: GetStatementRun
     */
    getStatementRun(input: GetStatementRunReq, options?: RpcOptions): UnaryCall<GetStatementRunReq, GetStatementRunRes>;
    /**
     * @generated from protobuf rpc: GetStatementRunStats
     */
    getStatementRunStats(input: GetStatementRunStatsReq, options?: RpcOptions): UnaryCall<GetStatementRunStatsReq, GetStatementRunStatsRes>;
    /**
     * @generated from protobuf rpc: EmailAllInStatementRun
     */
    emailAllInStatementRun(input: EmailAllInStatementRunReq, options?: RpcOptions): UnaryCall<EmailAllInStatementRunReq, EmailAllInStatementRunRes>;
    /**
     * @generated from protobuf rpc: CountCustomersForBulkStatement
     */
    countCustomersForBulkStatement(input: CountCustomersForBulkStatementReq, options?: RpcOptions): UnaryCall<CountCustomersForBulkStatementReq, CountCustomersForBulkStatementRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriod
     */
    updateCustomerRestrictOutstandingInvoicesToStatementPeriod(input: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, options?: RpcOptions): UnaryCall<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes>;
    /**
     * @generated from protobuf rpc: GenerateStatementRunPdfs
     */
    generateStatementRunPdfs(input: GenerateStatementRunPdfsReq, options?: RpcOptions): UnaryCall<GenerateStatementRunPdfsReq, GenerateStatementRunPdfsRes>;
    /**
     * @generated from protobuf rpc: GetLastStatementRunId
     */
    getLastStatementRunId(input: GetLastStatementRunIdReq, options?: RpcOptions): UnaryCall<GetLastStatementRunIdReq, GetLastStatementRunIdRes>;
    /**
     * @generated from protobuf rpc: GetLastStatementRunSendStats
     */
    getLastStatementRunSendStats(input: GetLastStatementRunSendStatsReq, options?: RpcOptions): UnaryCall<GetLastStatementRunSendStatsReq, GetLastStatementRunSendStatsRes>;
    /**
     * @generated from protobuf rpc: GenerateAndSendIndividualCustomerStatement
     */
    generateAndSendIndividualCustomerStatement(input: GenerateAndSendIndividualCustomerStatementReq, options?: RpcOptions): UnaryCall<GenerateAndSendIndividualCustomerStatementReq, GenerateAndSendIndividualCustomerStatementRes>;
    /**
     * Payment Card
     *
     * @generated from protobuf rpc: GetCustomerSavedCards
     */
    getCustomerSavedCards(input: GetCustomerSavedCardsReq, options?: RpcOptions): UnaryCall<GetCustomerSavedCardsReq, GetCustomerSavedCardsRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerPrimaryCard
     */
    updateCustomerPrimaryCard(input: UpdateCustomerPrimaryCardReq, options?: RpcOptions): UnaryCall<UpdateCustomerPrimaryCardReq, UpdateCustomerPrimaryCardRes>;
    /**
     * @generated from protobuf rpc: DeleteCustomerCard
     */
    deleteCustomerCard(input: DeleteCustomerCardReq, options?: RpcOptions): UnaryCall<DeleteCustomerCardReq, DeleteCustomerCardRes>;
    /**
     * @generated from protobuf rpc: AddCustomerCard
     */
    addCustomerCard(input: AddCustomerCardReq, options?: RpcOptions): UnaryCall<AddCustomerCardReq, AddCustomerCardRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerCard
     */
    updateCustomerCard(input: UpdateCustomerCardReq, options?: RpcOptions): UnaryCall<UpdateCustomerCardReq, UpdateCustomerCardRes>;
    /**
     * Payment Bank Account
     *
     * @generated from protobuf rpc: SendACHPaymentEmailAndSms
     */
    sendACHPaymentEmailAndSms(input: SendACHPaymentEmailAndSmsReq, options?: RpcOptions): UnaryCall<SendACHPaymentEmailAndSmsReq, SendACHPaymentEmailAndSmsRes>;
    /**
     * @generated from protobuf rpc: GetCustomerSavedBankAccounts
     */
    getCustomerSavedBankAccounts(input: GetCustomerSavedBankAccountsReq, options?: RpcOptions): UnaryCall<GetCustomerSavedBankAccountsReq, GetCustomerSavedBankAccountsRes>;
    /**
     * Customer Contact
     *
     * @generated from protobuf rpc: CreateCustomerContact
     */
    createCustomerContact(input: CreateCustomerContactReq, options?: RpcOptions): UnaryCall<CreateCustomerContactReq, CreateCustomerContactRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerContact
     */
    updateCustomerContact(input: UpdateCustomerContactReq, options?: RpcOptions): UnaryCall<UpdateCustomerContactReq, UpdateCustomerContactRes>;
    /**
     * @generated from protobuf rpc: DeactivateCustomerContact
     */
    deactivateCustomerContact(input: DeactivateCustomerContactReq, options?: RpcOptions): UnaryCall<DeactivateCustomerContactReq, DeactivateCustomerContactRes>;
    /**
     * Customer Sale History
     *
     * @generated from protobuf rpc: GetCustomerSaleHistoryPDF
     */
    getCustomerSaleHistoryPDF(input: GetCustomerSaleHistoryPDFReq, options?: RpcOptions): UnaryCall<GetCustomerSaleHistoryPDFReq, GetCustomerSaleHistoryPDFRes>;
    /**
     * @generated from protobuf rpc: EmailCustomerSaleHistoryPDF
     */
    emailCustomerSaleHistoryPDF(input: EmailCustomerSaleHistoryPDFReq, options?: RpcOptions): UnaryCall<EmailCustomerSaleHistoryPDFReq, EmailCustomerSaleHistoryPDFRes>;
    /**
     * Contractor Rewards Invitation
     *
     * @generated from protobuf rpc: EmailContractorRewardsInvitation
     */
    emailContractorRewardsInvitation(input: EmailContractorRewardsInvitationReq, options?: RpcOptions): UnaryCall<EmailContractorRewardsInvitationReq, EmailContractorRewardsInvitationRes>;
    /**
     * BUB
     *
     * @generated from protobuf rpc: BulkUpsertCustomers
     */
    bulkUpsertCustomers(input: BulkUpsertCustomersReq, options?: RpcOptions): UnaryCall<BulkUpsertCustomersReq, BulkUpsertCustomersRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertCustomerContacts
     */
    bulkUpsertCustomerContacts(input: BulkUpsertCustomerContactsReq, options?: RpcOptions): UnaryCall<BulkUpsertCustomerContactsReq, BulkUpsertCustomerContactsRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertJobs
     */
    bulkUpsertJobs(input: BulkUpsertJobsReq, options?: RpcOptions): UnaryCall<BulkUpsertJobsReq, BulkUpsertJobsRes>;
    /**
     * Job
     *
     * @generated from protobuf rpc: GenerateNextJobIdentifier
     */
    generateNextJobIdentifier(input: GenerateNextJobIdentifierReq, options?: RpcOptions): UnaryCall<GenerateNextJobIdentifierReq, GenerateNextJobIdentifierRes>;
    /**
     * @generated from protobuf rpc: CreateJob
     */
    createJob(input: CreateJobReq, options?: RpcOptions): UnaryCall<CreateJobReq, CreateJobRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldReceiveJobStatements
     */
    updateCustomerShouldReceiveJobStatements(input: UpdateCustomerShouldReceiveJobStatementsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldReceiveJobStatementsReq, UpdateCustomerShouldReceiveJobStatementsRes>;
    /**
     * @generated from protobuf rpc: ConvertToJob
     */
    convertToJob(input: ConvertToJobReq, options?: RpcOptions): UnaryCall<ConvertToJobReq, ConvertToJobRes>;
    /**
     * Tags
     *
     * @generated from protobuf rpc: ListCustomerTags
     */
    listCustomerTags(input: ListCustomerTagsReq, options?: RpcOptions): UnaryCall<ListCustomerTagsReq, ListCustomerTagsRes>;
    /**
     * @generated from protobuf rpc: AttachNewCustomerTag
     */
    attachNewCustomerTag(input: AttachNewCustomerTagReq, options?: RpcOptions): UnaryCall<AttachNewCustomerTagReq, AttachNewCustomerTagRes>;
    /**
     * @generated from protobuf rpc: AttachCustomerTag
     */
    attachCustomerTag(input: AttachCustomerTagReq, options?: RpcOptions): UnaryCall<AttachCustomerTagReq, AttachCustomerTagRes>;
    /**
     * @generated from protobuf rpc: DetachCustomerTag
     */
    detachCustomerTag(input: DetachCustomerTagReq, options?: RpcOptions): UnaryCall<DetachCustomerTagReq, DetachCustomerTagRes>;
}
/**
 * @generated from protobuf service rd.api.customer.CustomerService
 */
export class CustomerServiceClient implements ICustomerServiceClient, ServiceInfo {
    typeName = CustomerService.typeName;
    methods = CustomerService.methods;
    options = CustomerService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Customer
     *
     * @generated from protobuf rpc: GetCustomer
     */
    getCustomer(input: GetCustomerReq, options?: RpcOptions): UnaryCall<GetCustomerReq, GetCustomerRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerReq, GetCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCustomer
     */
    createCustomer(input: CreateCustomerReq, options?: RpcOptions): UnaryCall<CreateCustomerReq, CreateCustomerRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCustomerReq, CreateCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DuplicateCustomer
     */
    duplicateCustomer(input: DuplicateCustomerReq, options?: RpcOptions): UnaryCall<DuplicateCustomerReq, DuplicateCustomerRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<DuplicateCustomerReq, DuplicateCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCustomerInteraction
     */
    createCustomerInteraction(input: CreateCustomerInteractionReq, options?: RpcOptions): UnaryCall<CreateCustomerInteractionReq, CreateCustomerInteractionRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCustomerInteractionReq, CreateCustomerInteractionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerGeneralInformation
     */
    updateCustomerGeneralInformation(input: UpdateCustomerGeneralInformationReq, options?: RpcOptions): UnaryCall<UpdateCustomerGeneralInformationReq, UpdateCustomerGeneralInformationRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerGeneralInformationReq, UpdateCustomerGeneralInformationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerExemptions
     */
    updateCustomerExemptions(input: UpdateCustomerExemptionsReq, options?: RpcOptions): UnaryCall<UpdateCustomerExemptionsReq, UpdateCustomerExemptionsRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerExemptionsReq, UpdateCustomerExemptionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerNotes
     */
    updateCustomerNotes(input: UpdateCustomerNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerNotesReq, UpdateCustomerNotesRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerNotesReq, UpdateCustomerNotesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerCreditLimit
     */
    updateCustomerCreditLimit(input: UpdateCustomerCreditLimitReq, options?: RpcOptions): UnaryCall<UpdateCustomerCreditLimitReq, UpdateCustomerCreditLimitRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerCreditLimitReq, UpdateCustomerCreditLimitRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerIsOnCreditHold
     */
    updateCustomerIsOnCreditHold(input: UpdateCustomerIsOnCreditHoldReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsOnCreditHoldReq, UpdateCustomerIsOnCreditHoldRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerIsOnCreditHoldReq, UpdateCustomerIsOnCreditHoldRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerIsActive
     */
    updateCustomerIsActive(input: UpdateCustomerIsActiveReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsActiveReq, UpdateCustomerIsActiveRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerIsActiveReq, UpdateCustomerIsActiveRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequirePO
     */
    updateCustomerShouldRequirePO(input: UpdateCustomerShouldRequirePOReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequirePOReq, UpdateCustomerShouldRequirePORes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequirePOReq, UpdateCustomerShouldRequirePORes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldPrintInvoicesAndReceipts
     */
    updateCustomerShouldPrintInvoicesAndReceipts(input: UpdateCustomerShouldPrintInvoicesAndReceiptsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldPrintInvoicesAndReceiptsReq, UpdateCustomerShouldPrintInvoicesAndReceiptsRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldPrintInvoicesAndReceiptsReq, UpdateCustomerShouldPrintInvoicesAndReceiptsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldAutopayStatementBalances
     */
    updateCustomerShouldAutopayStatementBalances(input: UpdateCustomerShouldAutopayStatementBalancesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldAutopayStatementBalancesReq, UpdateCustomerShouldAutopayStatementBalancesRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldAutopayStatementBalancesReq, UpdateCustomerShouldAutopayStatementBalancesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldMailStatements
     */
    updateCustomerShouldMailStatements(input: UpdateCustomerShouldMailStatementsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldMailStatementsReq, UpdateCustomerShouldMailStatementsRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldMailStatementsReq, UpdateCustomerShouldMailStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireCustomerContact
     */
    updateCustomerShouldRequireCustomerContact(input: UpdateCustomerShouldRequireCustomerContactReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireCustomerContactReq, UpdateCustomerShouldRequireCustomerContactRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequireCustomerContactReq, UpdateCustomerShouldRequireCustomerContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireSaleNotes
     */
    updateCustomerShouldRequireSaleNotes(input: UpdateCustomerShouldRequireSaleNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireSaleNotesReq, UpdateCustomerShouldRequireSaleNotesRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequireSaleNotesReq, UpdateCustomerShouldRequireSaleNotesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireInternalSaleNotes
     */
    updateCustomerShouldRequireInternalSaleNotes(input: UpdateCustomerShouldRequireInternalSaleNotesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireInternalSaleNotesReq, UpdateCustomerShouldRequireInternalSaleNotesRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequireInternalSaleNotesReq, UpdateCustomerShouldRequireInternalSaleNotesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerFinancingTerm
     */
    updateCustomerFinancingTerm(input: UpdateCustomerFinancingTermReq, options?: RpcOptions): UnaryCall<UpdateCustomerFinancingTermReq, UpdateCustomerFinancingTermRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerFinancingTermReq, UpdateCustomerFinancingTermRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerFinanceChargeSetting
     */
    updateCustomerFinanceChargeSetting(input: UpdateCustomerFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<UpdateCustomerFinanceChargeSettingReq, UpdateCustomerFinanceChargeSettingRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerFinanceChargeSettingReq, UpdateCustomerFinanceChargeSettingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerRep
     */
    updateCustomerRep(input: UpdateCustomerRepReq, options?: RpcOptions): UnaryCall<UpdateCustomerRepReq, UpdateCustomerRepRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerRepReq, UpdateCustomerRepRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPurchaseOrdersForCustomer
     */
    listPurchaseOrdersForCustomer(input: ListPurchaseOrdersForCustomerReq, options?: RpcOptions): UnaryCall<ListPurchaseOrdersForCustomerReq, ListPurchaseOrdersForCustomerRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPurchaseOrdersForCustomerReq, ListPurchaseOrdersForCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListInteractionsForCustomer
     */
    listInteractionsForCustomer(input: ListInteractionsForCustomerReq, options?: RpcOptions): UnaryCall<ListInteractionsForCustomerReq, ListInteractionsForCustomerRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListInteractionsForCustomerReq, ListInteractionsForCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerContractorRewards
     */
    updateCustomerContractorRewards(input: UpdateCustomerContractorRewardsReq, options?: RpcOptions): UnaryCall<UpdateCustomerContractorRewardsReq, UpdateCustomerContractorRewardsRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerContractorRewardsReq, UpdateCustomerContractorRewardsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireReceiptSignature
     */
    updateCustomerShouldRequireReceiptSignature(input: UpdateCustomerShouldRequireReceiptSignatureReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireReceiptSignatureReq, UpdateCustomerShouldRequireReceiptSignatureRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequireReceiptSignatureReq, UpdateCustomerShouldRequireReceiptSignatureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerPricingTier
     */
    updateCustomerPricingTier(input: UpdateCustomerPricingTierReq, options?: RpcOptions): UnaryCall<UpdateCustomerPricingTierReq, UpdateCustomerPricingTierRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerPricingTierReq, UpdateCustomerPricingTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerGeneralInfoMobile
     */
    updateCustomerGeneralInfoMobile(input: UpdateCustomerGeneralInfoMobileReq, options?: RpcOptions): UnaryCall<UpdateCustomerGeneralInfoMobileReq, UpdateCustomerGeneralInfoMobileRes> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerGeneralInfoMobileReq, UpdateCustomerGeneralInfoMobileRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerSalesReminder
     */
    updateCustomerSalesReminder(input: UpdateCustomerSalesReminderReq, options?: RpcOptions): UnaryCall<UpdateCustomerSalesReminderReq, UpdateCustomerSalesReminderRes> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerSalesReminderReq, UpdateCustomerSalesReminderRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCustomersForRep
     */
    listCustomersForRep(input: ListCustomersForRepReq, options?: RpcOptions): UnaryCall<ListCustomersForRepReq, ListCustomersForRepRes> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCustomersForRepReq, ListCustomersForRepRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCustomerCountForTier
     */
    getCustomerCountForTier(input: GetCustomerCountForTierReq, options?: RpcOptions): UnaryCall<GetCustomerCountForTierReq, GetCustomerCountForTierRes> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerCountForTierReq, GetCustomerCountForTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJobCountForCustomer
     */
    getJobCountForCustomer(input: GetJobCountForCustomerReq, options?: RpcOptions): UnaryCall<GetJobCountForCustomerReq, GetJobCountForCustomerRes> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJobCountForCustomerReq, GetJobCountForCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetActiveCustomerCount
     */
    getActiveCustomerCount(input: GetActiveCustomerCountReq, options?: RpcOptions): UnaryCall<GetActiveCustomerCountReq, GetActiveCustomerCountRes> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveCustomerCountReq, GetActiveCustomerCountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Fan Builder loyalty (FLAG_REWARD_PROGRAM_FAN_BUILDER). Human (non-job) customers only.
     *
     * @generated from protobuf rpc: EnrollCustomerInFanBuilderLoyalty
     */
    enrollCustomerInFanBuilderLoyalty(input: EnrollCustomerInFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<EnrollCustomerInFanBuilderLoyaltyReq, EnrollCustomerInFanBuilderLoyaltyRes> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnrollCustomerInFanBuilderLoyaltyReq, EnrollCustomerInFanBuilderLoyaltyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCustomerFanBuilderLoyalty
     */
    getCustomerFanBuilderLoyalty(input: GetCustomerFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<GetCustomerFanBuilderLoyaltyReq, GetCustomerFanBuilderLoyaltyRes> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerFanBuilderLoyaltyReq, GetCustomerFanBuilderLoyaltyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Removes the customer from Fan Builder (CES Customer/Delete) and clears the stored
     * enrollment (FLAG_REWARD_PROGRAM_FAN_BUILDER).
     *
     * @generated from protobuf rpc: UnenrollCustomerFromFanBuilderLoyalty
     */
    unenrollCustomerFromFanBuilderLoyalty(input: UnenrollCustomerFromFanBuilderLoyaltyReq, options?: RpcOptions): UnaryCall<UnenrollCustomerFromFanBuilderLoyaltyReq, UnenrollCustomerFromFanBuilderLoyaltyRes> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnenrollCustomerFromFanBuilderLoyaltyReq, UnenrollCustomerFromFanBuilderLoyaltyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * POS scanned barcode: Coupon/ValidateCoupon (FLAG_REWARD_PROGRAM_FAN_BUILDER).
     *
     * @generated from protobuf rpc: ValidateFanBuilderLoyaltyCoupon
     */
    validateFanBuilderLoyaltyCoupon(input: ValidateFanBuilderLoyaltyCouponReq, options?: RpcOptions): UnaryCall<ValidateFanBuilderLoyaltyCouponReq, ValidateFanBuilderLoyaltyCouponRes> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<ValidateFanBuilderLoyaltyCouponReq, ValidateFanBuilderLoyaltyCouponRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldRequireJob
     */
    updateCustomerShouldRequireJob(input: UpdateCustomerShouldRequireJobReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldRequireJobReq, UpdateCustomerShouldRequireJobRes> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldRequireJobReq, UpdateCustomerShouldRequireJobRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerStatementInvoicesFormat
     */
    updateCustomerStatementInvoicesFormat(input: UpdateCustomerStatementInvoicesFormatReq, options?: RpcOptions): UnaryCall<UpdateCustomerStatementInvoicesFormatReq, UpdateCustomerStatementInvoicesFormatRes> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerStatementInvoicesFormatReq, UpdateCustomerStatementInvoicesFormatRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldHidePricesOnInvoices
     */
    updateCustomerShouldHidePricesOnInvoices(input: UpdateCustomerShouldHidePricesOnInvoicesReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldHidePricesOnInvoicesReq, UpdateCustomerShouldHidePricesOnInvoicesRes> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldHidePricesOnInvoicesReq, UpdateCustomerShouldHidePricesOnInvoicesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerStatementType
     */
    updateCustomerStatementType(input: UpdateCustomerStatementTypeReq, options?: RpcOptions): UnaryCall<UpdateCustomerStatementTypeReq, UpdateCustomerStatementTypeRes> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerStatementTypeReq, UpdateCustomerStatementTypeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerType
     */
    updateCustomerType(input: UpdateCustomerTypeReq, options?: RpcOptions): UnaryCall<UpdateCustomerTypeReq, UpdateCustomerTypeRes> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerTypeReq, UpdateCustomerTypeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerIsCardSurchargeExempt
     */
    updateCustomerIsCardSurchargeExempt(input: UpdateCustomerIsCardSurchargeExemptReq, options?: RpcOptions): UnaryCall<UpdateCustomerIsCardSurchargeExemptReq, UpdateCustomerIsCardSurchargeExemptRes> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerIsCardSurchargeExemptReq, UpdateCustomerIsCardSurchargeExemptRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MergeCustomers
     */
    mergeCustomers(input: MergeCustomersReq, options?: RpcOptions): UnaryCall<MergeCustomersReq, MergeCustomersRes> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<MergeCustomersReq, MergeCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Statement
     *
     * @generated from protobuf rpc: GetLastStatementRun
     */
    getLastStatementRun(input: GetLastStatementRunReq, options?: RpcOptions): UnaryCall<GetLastStatementRunReq, GetLastStatementRunRes> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLastStatementRunReq, GetLastStatementRunRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MailBulkStatementRun
     */
    mailBulkStatementRun(input: MailBulkStatementRunReq, options?: RpcOptions): UnaryCall<MailBulkStatementRunReq, MailBulkStatementRunRes> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<MailBulkStatementRunReq, MailBulkStatementRunRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListStatementsForCustomer
     */
    listStatementsForCustomer(input: ListStatementsForCustomerReq, options?: RpcOptions): UnaryCall<ListStatementsForCustomerReq, ListStatementsForCustomerRes> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListStatementsForCustomerReq, ListStatementsForCustomerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailCustomerStatementPDF
     */
    emailCustomerStatementPDF(input: EmailCustomerStatementPDFReq, options?: RpcOptions): UnaryCall<EmailCustomerStatementPDFReq, EmailCustomerStatementPDFRes> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailCustomerStatementPDFReq, EmailCustomerStatementPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateStatementsForCustomers
     */
    generateStatementsForCustomers(input: GenerateStatementsForCustomersReq, options?: RpcOptions): UnaryCall<GenerateStatementsForCustomersReq, GenerateStatementsForCustomersRes> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateStatementsForCustomersReq, GenerateStatementsForCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkGenerateStatementsForCustomers
     */
    bulkGenerateStatementsForCustomers(input: BulkGenerateStatementsForCustomersReq, options?: RpcOptions): UnaryCall<BulkGenerateStatementsForCustomersReq, BulkGenerateStatementsForCustomersRes> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGenerateStatementsForCustomersReq, BulkGenerateStatementsForCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailStatementRun
     */
    emailStatementRun(input: EmailStatementRunReq, options?: RpcOptions): UnaryCall<EmailStatementRunReq, EmailStatementRunRes> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailStatementRunReq, EmailStatementRunRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStatementRun
     */
    getStatementRun(input: GetStatementRunReq, options?: RpcOptions): UnaryCall<GetStatementRunReq, GetStatementRunRes> {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStatementRunReq, GetStatementRunRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStatementRunStats
     */
    getStatementRunStats(input: GetStatementRunStatsReq, options?: RpcOptions): UnaryCall<GetStatementRunStatsReq, GetStatementRunStatsRes> {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStatementRunStatsReq, GetStatementRunStatsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailAllInStatementRun
     */
    emailAllInStatementRun(input: EmailAllInStatementRunReq, options?: RpcOptions): UnaryCall<EmailAllInStatementRunReq, EmailAllInStatementRunRes> {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailAllInStatementRunReq, EmailAllInStatementRunRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountCustomersForBulkStatement
     */
    countCustomersForBulkStatement(input: CountCustomersForBulkStatementReq, options?: RpcOptions): UnaryCall<CountCustomersForBulkStatementReq, CountCustomersForBulkStatementRes> {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountCustomersForBulkStatementReq, CountCustomersForBulkStatementRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriod
     */
    updateCustomerRestrictOutstandingInvoicesToStatementPeriod(input: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, options?: RpcOptions): UnaryCall<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes> {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateStatementRunPdfs
     */
    generateStatementRunPdfs(input: GenerateStatementRunPdfsReq, options?: RpcOptions): UnaryCall<GenerateStatementRunPdfsReq, GenerateStatementRunPdfsRes> {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateStatementRunPdfsReq, GenerateStatementRunPdfsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLastStatementRunId
     */
    getLastStatementRunId(input: GetLastStatementRunIdReq, options?: RpcOptions): UnaryCall<GetLastStatementRunIdReq, GetLastStatementRunIdRes> {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLastStatementRunIdReq, GetLastStatementRunIdRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLastStatementRunSendStats
     */
    getLastStatementRunSendStats(input: GetLastStatementRunSendStatsReq, options?: RpcOptions): UnaryCall<GetLastStatementRunSendStatsReq, GetLastStatementRunSendStatsRes> {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLastStatementRunSendStatsReq, GetLastStatementRunSendStatsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateAndSendIndividualCustomerStatement
     */
    generateAndSendIndividualCustomerStatement(input: GenerateAndSendIndividualCustomerStatementReq, options?: RpcOptions): UnaryCall<GenerateAndSendIndividualCustomerStatementReq, GenerateAndSendIndividualCustomerStatementRes> {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateAndSendIndividualCustomerStatementReq, GenerateAndSendIndividualCustomerStatementRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Payment Card
     *
     * @generated from protobuf rpc: GetCustomerSavedCards
     */
    getCustomerSavedCards(input: GetCustomerSavedCardsReq, options?: RpcOptions): UnaryCall<GetCustomerSavedCardsReq, GetCustomerSavedCardsRes> {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerSavedCardsReq, GetCustomerSavedCardsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerPrimaryCard
     */
    updateCustomerPrimaryCard(input: UpdateCustomerPrimaryCardReq, options?: RpcOptions): UnaryCall<UpdateCustomerPrimaryCardReq, UpdateCustomerPrimaryCardRes> {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerPrimaryCardReq, UpdateCustomerPrimaryCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCustomerCard
     */
    deleteCustomerCard(input: DeleteCustomerCardReq, options?: RpcOptions): UnaryCall<DeleteCustomerCardReq, DeleteCustomerCardRes> {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteCustomerCardReq, DeleteCustomerCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddCustomerCard
     */
    addCustomerCard(input: AddCustomerCardReq, options?: RpcOptions): UnaryCall<AddCustomerCardReq, AddCustomerCardRes> {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddCustomerCardReq, AddCustomerCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerCard
     */
    updateCustomerCard(input: UpdateCustomerCardReq, options?: RpcOptions): UnaryCall<UpdateCustomerCardReq, UpdateCustomerCardRes> {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerCardReq, UpdateCustomerCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Payment Bank Account
     *
     * @generated from protobuf rpc: SendACHPaymentEmailAndSms
     */
    sendACHPaymentEmailAndSms(input: SendACHPaymentEmailAndSmsReq, options?: RpcOptions): UnaryCall<SendACHPaymentEmailAndSmsReq, SendACHPaymentEmailAndSmsRes> {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept<SendACHPaymentEmailAndSmsReq, SendACHPaymentEmailAndSmsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCustomerSavedBankAccounts
     */
    getCustomerSavedBankAccounts(input: GetCustomerSavedBankAccountsReq, options?: RpcOptions): UnaryCall<GetCustomerSavedBankAccountsReq, GetCustomerSavedBankAccountsRes> {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerSavedBankAccountsReq, GetCustomerSavedBankAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Customer Contact
     *
     * @generated from protobuf rpc: CreateCustomerContact
     */
    createCustomerContact(input: CreateCustomerContactReq, options?: RpcOptions): UnaryCall<CreateCustomerContactReq, CreateCustomerContactRes> {
        const method = this.methods[65], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCustomerContactReq, CreateCustomerContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerContact
     */
    updateCustomerContact(input: UpdateCustomerContactReq, options?: RpcOptions): UnaryCall<UpdateCustomerContactReq, UpdateCustomerContactRes> {
        const method = this.methods[66], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerContactReq, UpdateCustomerContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateCustomerContact
     */
    deactivateCustomerContact(input: DeactivateCustomerContactReq, options?: RpcOptions): UnaryCall<DeactivateCustomerContactReq, DeactivateCustomerContactRes> {
        const method = this.methods[67], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateCustomerContactReq, DeactivateCustomerContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Customer Sale History
     *
     * @generated from protobuf rpc: GetCustomerSaleHistoryPDF
     */
    getCustomerSaleHistoryPDF(input: GetCustomerSaleHistoryPDFReq, options?: RpcOptions): UnaryCall<GetCustomerSaleHistoryPDFReq, GetCustomerSaleHistoryPDFRes> {
        const method = this.methods[68], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerSaleHistoryPDFReq, GetCustomerSaleHistoryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailCustomerSaleHistoryPDF
     */
    emailCustomerSaleHistoryPDF(input: EmailCustomerSaleHistoryPDFReq, options?: RpcOptions): UnaryCall<EmailCustomerSaleHistoryPDFReq, EmailCustomerSaleHistoryPDFRes> {
        const method = this.methods[69], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailCustomerSaleHistoryPDFReq, EmailCustomerSaleHistoryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Contractor Rewards Invitation
     *
     * @generated from protobuf rpc: EmailContractorRewardsInvitation
     */
    emailContractorRewardsInvitation(input: EmailContractorRewardsInvitationReq, options?: RpcOptions): UnaryCall<EmailContractorRewardsInvitationReq, EmailContractorRewardsInvitationRes> {
        const method = this.methods[70], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailContractorRewardsInvitationReq, EmailContractorRewardsInvitationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * BUB
     *
     * @generated from protobuf rpc: BulkUpsertCustomers
     */
    bulkUpsertCustomers(input: BulkUpsertCustomersReq, options?: RpcOptions): UnaryCall<BulkUpsertCustomersReq, BulkUpsertCustomersRes> {
        const method = this.methods[71], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertCustomersReq, BulkUpsertCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertCustomerContacts
     */
    bulkUpsertCustomerContacts(input: BulkUpsertCustomerContactsReq, options?: RpcOptions): UnaryCall<BulkUpsertCustomerContactsReq, BulkUpsertCustomerContactsRes> {
        const method = this.methods[72], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertCustomerContactsReq, BulkUpsertCustomerContactsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertJobs
     */
    bulkUpsertJobs(input: BulkUpsertJobsReq, options?: RpcOptions): UnaryCall<BulkUpsertJobsReq, BulkUpsertJobsRes> {
        const method = this.methods[73], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertJobsReq, BulkUpsertJobsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Job
     *
     * @generated from protobuf rpc: GenerateNextJobIdentifier
     */
    generateNextJobIdentifier(input: GenerateNextJobIdentifierReq, options?: RpcOptions): UnaryCall<GenerateNextJobIdentifierReq, GenerateNextJobIdentifierRes> {
        const method = this.methods[74], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateNextJobIdentifierReq, GenerateNextJobIdentifierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateJob
     */
    createJob(input: CreateJobReq, options?: RpcOptions): UnaryCall<CreateJobReq, CreateJobRes> {
        const method = this.methods[75], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateJobReq, CreateJobRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomerShouldReceiveJobStatements
     */
    updateCustomerShouldReceiveJobStatements(input: UpdateCustomerShouldReceiveJobStatementsReq, options?: RpcOptions): UnaryCall<UpdateCustomerShouldReceiveJobStatementsReq, UpdateCustomerShouldReceiveJobStatementsRes> {
        const method = this.methods[76], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomerShouldReceiveJobStatementsReq, UpdateCustomerShouldReceiveJobStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConvertToJob
     */
    convertToJob(input: ConvertToJobReq, options?: RpcOptions): UnaryCall<ConvertToJobReq, ConvertToJobRes> {
        const method = this.methods[77], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConvertToJobReq, ConvertToJobRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Tags
     *
     * @generated from protobuf rpc: ListCustomerTags
     */
    listCustomerTags(input: ListCustomerTagsReq, options?: RpcOptions): UnaryCall<ListCustomerTagsReq, ListCustomerTagsRes> {
        const method = this.methods[78], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCustomerTagsReq, ListCustomerTagsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AttachNewCustomerTag
     */
    attachNewCustomerTag(input: AttachNewCustomerTagReq, options?: RpcOptions): UnaryCall<AttachNewCustomerTagReq, AttachNewCustomerTagRes> {
        const method = this.methods[79], opt = this._transport.mergeOptions(options);
        return stackIntercept<AttachNewCustomerTagReq, AttachNewCustomerTagRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AttachCustomerTag
     */
    attachCustomerTag(input: AttachCustomerTagReq, options?: RpcOptions): UnaryCall<AttachCustomerTagReq, AttachCustomerTagRes> {
        const method = this.methods[80], opt = this._transport.mergeOptions(options);
        return stackIntercept<AttachCustomerTagReq, AttachCustomerTagRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DetachCustomerTag
     */
    detachCustomerTag(input: DetachCustomerTagReq, options?: RpcOptions): UnaryCall<DetachCustomerTagReq, DetachCustomerTagRes> {
        const method = this.methods[81], opt = this._transport.mergeOptions(options);
        return stackIntercept<DetachCustomerTagReq, DetachCustomerTagRes>("unary", this._transport, method, opt, input);
    }
}
